import styled from 'styled-components';
import { breakpoints } from '../../../styles/screenSizes';

export const MobileDropdownContents = styled.div`
    width: 100%;
    background-color: #fff;
    border-top: 1px solid #dbf0ff;
    display: flex;
    flex-direction: column;
    gap: 24px;
    max-height: 100vh;
`;

export const MenuItemsWrapper = styled.div`
    max-height: 700px;
    overflow-y: auto;
`;

export const MenuCategoryContainer = styled.div`
    width: 100%;
    background: linear-gradient(90deg, #e0f2fe 0.7%, #ffffff 100%);
    transition: height 0.4s ease;
`;

export const NavButtonContainer = styled.div`
    padding: 16px 0px;
    border-top: 1px solid #dbf0ff;
`;

export const CategoryOptions = styled.div`
    padding: 18px 0px 18px 18px;
`;

export const SubMenuContainer = styled.div`
    margin: 0 24px;
    padding: ${({ active }) => (active ? '20px' : ' 0px')};
    background-color: #fff;
    border-radius: 5px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 36px;
    font-size: 14px;
    height: ${({ submenuHeight }) => submenuHeight && `${submenuHeight}px`};
    overflow: hidden;
    transition: height 0.3s ease;

    @media (max-width: ${breakpoints.sm}) {
        grid-template-columns: 1fr;
    }
`;
